import { Injectable } from "@angular/core";
import { ConditionEntity, ConditionType } from "@edp-bif/common-api";

@Injectable()
export class StartConditionService {
    createConditionEntity(): ConditionEntity {
        const entity = new ConditionEntity();
        entity.id = this.generateGUID();
        entity.isEnabled = true;
        entity.type = ConditionType.COMPONENT;
        return entity;
    }

    generateGUID(): string {
        let d = new Date().getTime();
        let guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            let r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });

        return guid;
    }
}